<template>
  <div class="status-section-group ds-margin-bottom-48">
    <div
      v-for="(item, index) in computedData"
      :key="`status-section-group-${index}`"
      class="ds-width-full"
    >
      <StatusSection v-bind="{ ...item, type: type }">
        <template v-slot:statusSectionButton>
          <slot name="statusSectionButton" :tracking-data="{ 'component-name': $options.name }" />
        </template>
      </StatusSection>
    </div>
    <section>
      <div class="ds-container">
        <div class="ds-grid ds-justify-content-center">
          <div class="ds-grid__col ds-grid__col--12 ds-lg-grid__col--10">
            <button
              v-if="items.length > 3"
              type="button"
              class="ds-margin-top-48 ds-button ds-button--primary ds-button--black"
              :data-track-component-name="$options.name"
              :data-track-text="computedButtonLabel"
              @click="toggleMonths"
            >
              {{ computedButtonLabel }}
            </button>
            <span
              v-if="linkBack"
              class="ds-padding-y-24 ds-md-padding-y-48"
              :style="{ display: 'block' }"
            >
              <DsDivider />
            </span>
            <DsLinkBack
              v-if="linkBack"
              :text="linkBack.label"
              :url="linkBack.url"
              :data-track-component-name="$options.name"
              :data-track-text="linkBack.label"
              color="black"
              nuxt
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import DsDivider from 'website-design-system/src/atoms/divider/divider';
import DsLinkBack from 'website-design-system/src/molecules/link-back/link-back';
import { StatusSection } from '@/components';
import { MIN_NUMBER_OF_ITEMS } from '@/constants';
export default {
  name: 'StatusSectionGroup',
  components: { DsDivider, DsLinkBack, StatusSection },
  props: {
    items: {
      type: Array,
      required: true,
      validator: arr => arr.length <= 12 && arr.every(obj => ['title', 'items'].every(key => key in obj))
    },
    type: {
      type: String,
      required: true,
      validator: str => ['maintenance', 'incident'].includes(str)
    },
    linkBack: {
      type: Object,
      default: null,
      validator: obj => ['label', 'url'].every(key => key in obj)
    }
  },
  data: () => ({
    monthsToShow: MIN_NUMBER_OF_ITEMS
  }),
  computed: {
    cardColor () {
      return this.type === 'maintenance' ? 'grey' : 'light';
    },
    computedData () {
      return this.items.slice(0, this.monthsToShow);
    },
    computedButtonLabel () {
      return this.monthsToShow === this.items.length ? this.$labels.showLess : this.$labels.showAllMonths;
    }
  },
  methods: {
    toggleMonths () {
      if (this.monthsToShow === MIN_NUMBER_OF_ITEMS) {
        this.monthsToShow = this.items.length;
      } else {
        this.monthsToShow = MIN_NUMBER_OF_ITEMS;
      }
    }
  }
}
</script>
